export enum EntityStoreKey {
  emailProviders = 'emailProviders',
  sharedEmailProviders = 'sharedEmailProviders',
}
export enum EmailProvidersErrors {
  onPremise = 'potential_on_premise',
}
